/**
 * Email validation regex
 * Matches standard email format: local@domain.tld
 */
const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/**
 * Validate email format
 *
 * @param email - The email to validate
 * @returns true if email is valid format
 *
 * @example
 * ```ts
 * validateEmail("user@example.com"); // true
 * validateEmail("invalid"); // false
 * validateEmail("user@"); // false
 * ```
 */
export const validateEmail = (email: string): boolean => {
  return EMAIL_REGEX.test(email);
};

/**
 * Normalize email address
 * Trims whitespace and converts to lowercase
 *
 * @param email - The email to normalize
 * @returns Normalized email
 */
export const normalizeEmail = (email: string): string => {
  return email.toLowerCase().trim();
};

/**
 * Validate and normalize email
 *
 * @param email - The email to validate and normalize
 * @returns Object with isValid flag and normalized email
 */
export const validateAndNormalizeEmail = (
  email: string,
): { isValid: boolean; email: string } => {
  const normalized = normalizeEmail(email);
  return {
    isValid: validateEmail(normalized),
    email: normalized,
  };
};
